var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"header--wrap"},[_c('h1',{staticClass:"site--title"},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_vm._v("Paracelsia Le Saigné")])],1),_c('TheNavigation')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }